import {
  Box,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import oracle_fusion from "../../../Images/Oracle/oracle_fusion.jpeg";
// import E_Business from "../../../Images/Oracle/oracle_Esite.jpg";
// import service from "../../../Images/Oracle/oracle_service.jpg";
// import linux from "../../../Images/Oracle/linux.jpg";
import { commonCss } from "../../../CssStyle/commonCss";
import {
  Done,
  BalanceOutlined,
  CodeOffOutlined,
  FiberManualRecord,
  HowToVote,
  InsertChart,
  PeopleAltOutlined,
  PieChartOutline,
  TaskAlt,
  WorkspacesRounded,
} from "@mui/icons-material";

const Oracle = () => {
  return (
    <Grid2 container>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            mt={{ xs: "30%", sm: "20%", md: "15%", lg: "13%", xl: "8%" }}
            sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Oracle Fusion Cloud
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              The Oracle Cloud is here, and it is the way of the future. Solver
              Thoughts Technologies has extensive experience helping clients
              make their way into the Cloud. The Oracle Cloud is the industry’s
              broadest and most integrated public cloud. It offers best-in-class
              services across software as a service (SaaS), platform as a
              service (PaaS), and infrastructure as a service (IaaS)
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontWeight: 600,
                  lineHeight: "normal",
                  height: "fit-content",
                }}
              >
                The best team to Implement and Support Oracle Fusion Cloud
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  color: commonCss.darkGray,
                  height: "fit-content",
                }}
              >
                Has your organization started to evaluate if the Oracle Cloud is
                right for you? Speak to one of our Cloud experts and learn more
                about the benefits of transitioning to the Oracle Cloud.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  height: "fit-content",
                  color: commonCss.darkGray,
                }}
              >
                We offer flexible project options for your implementation to fit
                your specific applications and business requirements. Our
                experienced team will engineer a low-cost and business-ready
                solution ideal to your need sand help you every step of the way.
              </Typography>
              <Box
                component={"img"}
                src={"/Images/Oracle/oracle_fusion.jpeg"}
                alt="oracle fusion"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <WorkspacesRounded
                  sx={{ color: commonCss.blue, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Oracle Cloud Upgrade
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Solver Thoughts is your go-to partner for Fusion upgrade
                    success.Our professionals on your project are knowledgeable
                    and experienced Oracle professionals working to upgrade your
                    Oracle Fusion application.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Why S2T
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Our experienced team is in your corner, and will customize
                    your project to get you up and running on time and on
                    budget.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PeopleAltOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Oracle Cloud Managed Services
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We are the Oracle ERP Cloud & HCM Cloud experts. Our
                    consultants have been implementing and managing Oracle
                    solutions for more than 15 years. For this reason, we are
                    the ideal partner to help you with your Cloud managed
                    services.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <BalanceOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Projects we handle
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Assessments <br />
                    Project Leadership <br />
                    Technical leads <br />
                    Testing
                    <br />
                    Transition & Training
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Oracle E-Business Suite
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              Thousands of organizations around the world still rely on Oracle
              E-Business Suite to run their key business operations.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontWeight: 600,
                  lineHeight: "normal",
                  height: "fit-content",
                }}
              >
                Implement ,Customize and Support any version of your Oracle
                E-Business Suite
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  color: commonCss.darkGray,
                  height: "fit-content",
                }}
              >
                E-Business suite has hundreds of cross-industry capabilities
                spanning Financials, Procurement , Supply chain planning (SCM),
                Human capital management (HCM), Customer relationship management
                (CRM), and Manufacturing (MFG) for organizations of all sizes.
                Often, organizations use EBS as the core and further extend it
                with significant customizations and intricate integrations. It
                is natural that these organizations require solutions that are
                scalable, cost-effective, agile, and provide efficiency.
              </Typography>

              <Box
                component={"img"}
                src={"/Images/Oracle/oracle_Esite.jpg"}
                alt="E-Business"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <InsertChart
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    EBS Experience​
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Our consultants have on average more than 10 years of
                    experience implementing and upgrading EBS. Some of our key
                    consultants have been working with the application for
                    almost 15 years!​
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PeopleAltOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Consultants Experience
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Solver Thoughts Technologies consultants has been helping
                    customers for more than 15 years.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <HowToVote
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    On-Premise and Cloud
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Our expert consultants help organizations deploy their EBS
                    on-premise or on cloud and even a hybrid model.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <CodeOffOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Integrations
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We offer a wide array of out-of-the-box integration
                    solutions for better financial control, improved operational
                    effectiveness, and better corporate alignment.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PieChartOutline
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Analytics and Reporting
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We develop reporting and analytics solution that enables
                    business users and decision makers to make better decisions.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Oracle Managed Services
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              We have experienced staff that can take over where you need us the
              most. Our experts become an extension of your team, providing you
              with the talent and knowledge to optimize your processes.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontWeight: 600,
                  lineHeight: "normal",
                  height: "fit-content",
                }}
              >
                Get the best results from the experts.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  color: commonCss.darkGray,
                  height: "fit-content",
                }}
              >
                We offer subject matter expertise on Procurement ,Human Capital
                Management, Financials (including Public Sector modules),
                Projects, Data Analysis, Grants, Manufacturing and Customer
                Relationship Management, Reporting and Analytics, Business
                Intelligence and Data Warehousing.
              </Typography>

              <Box
                component={"img"}
                src={"/Images/Oracle/oracle_service.jpg"}
                alt="E-Business"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PeopleAltOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Oracle Support
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Managed Services for support provides clients with the
                    ability to have access to expert consultants to respond to
                    any type of question or deliverable, big or small. Solver
                    Thoughts thrives on partnering with its customers and
                    empowering them with the ability to independently maintain
                    their own systems.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PieChartOutline
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Report Writing
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We help clients get better access to their data by creating
                    value added reporting solutions and developing custom
                    reports that directly increase operational efficiency in
                    areas such as month end close, reconciliation, and much
                    more.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Linux Managed Services
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              You can rely on us for keeping your Mission Critical IT
              environments up and running. In your own datacenter, or just any
              cloud.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.5rem", md: "2rem" },
                  fontWeight: 600,
                  lineHeight: "normal",
                  height: "fit-content",
                }}
              >
                If you are running Linux® systems, you should be working with
                Solver Thoughts
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  color: commonCss.darkGray,
                  height: "fit-content",
                }}
              >
                We have one of the most experienced Linux team and a complete
                portfolio of Linux Managed Services to choose from.
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: "1.1rem", md: "1.2rem" },
                  color: commonCss.darkGray,
                  height: "fit-content",
                }}
              >
                Linux systems often perform important functions for your
                business. They also require specialist skills to get the best
                out of them. Often organizations have strong Windows skills but
                don’t want to hire or train dedicated Linux support staff. This
                is where Solver Thoughts’s Linux Managed Services can help.
              </Typography>
              <Box
                component={"img"}
                src={"/Images/Oracle/linux.jpg"}
                alt="Linux"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <BalanceOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    24/7 Response
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Our team responds to critical alarms and service down issues
                    24/7/365 to manage you and your clients critical Linux cloud
                    infrastructure.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <InsertChart
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Configuration & Implementation
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    End-to-end Linux server-side management, deployment and
                    configuration inc. load balancers, firewalls and network
                    updates and configuration changes.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                      textAlign: "center",
                    }}
                  >
                    Linux Security
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      textAlign: "center",
                      color: commonCss.darkGray,
                    }}
                  >
                    System security management & ongoing advice is provided to
                    all clients as part of their managed service. We take care
                    of all server side patching, access controls and monitoring.
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2
              container
              justifyContent={"center"}
              size={{ xs: 12 }}
              spacing={"2rem"}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <PeopleAltOutlined
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", md: "2rem" },
                    fontWeight: 600,
                    lineHeight: "normal",
                    textAlign: "center",
                  }}
                >
                  Linux Services
                </Typography>
              </Box>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  Support
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />

                    <ListItemText>24 x 7 telephone support</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>
                      Management of manufacturer support
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  Monitoring
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>24 x7 Remote Monitoring</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Performance Optimization</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  Hosting
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>
                      Physical and virtual server options.
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Fully managed service.</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  System Administration
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0 }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>On site or Remote Services</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>
                      Let us manage your systems for you.
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  Linux Clustering & Replication Solutions
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Clustering for Oracle and SAP</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>
                      Linux DR and Business Continuity
                    </ListItemText>
                  </ListItem>
                </List>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <Typography
                  sx={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    fontFamily: "inherit",
                    mt: 4,
                    textAlign: "center",
                  }}
                >
                  Linux Professional Services
                </Typography>
                <List
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "1rem",
                      fontWeight: 300,
                    },
                    "& .MuiListItem-root ": {
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                      gap: "1rem",
                    },

                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    columnGap: "1rem",
                    rowGap: "0.5rem",
                    flexWrap: "wrap",
                    width: "100%",
                    mt: "1rem",
                  }}
                >
                  <ListItem sx={{ p: 0 }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Linux Migration</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Linux Deployment Services</ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: 0 }}>
                    <FiberManualRecord sx={{ fontSize: "0.8rem" }} />
                    <ListItemText>Linux Virtualization</ListItemText>
                  </ListItem>
                </List>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Oracle;
